// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const Modal = require('client-v2/common/components/modal')
const ArticleModelRecord = require('client-v2/common/models/article/record')
// Sibling imports
const ArticlePreview = require('./components/article-preview')
const UrlForm = require('./components/url-form')

const bem = BemEntity('ContentAddModal')

class ContentAddModal extends React.PureComponent {
  constructor(props) {
    super(props)
  }

  // Render methods

  renderArticlePreview() {
    const { article, isArticleLoading } = this.props
    return (
      tag('div', {
        className: bem.element('article')
      },
        tag(ArticlePreview, {
          article,
          isArticleLoading
        })
      )
    )
  }

  renderURLForm() {
    const { props } = this
    return (
      tag(UrlForm, {
        ...props
      })
    )
  }

  renderInner() {
    return (
      tag('div', {
        className: bem.element('inner')
      },
        this.renderArticlePreview(),
        this.renderURLForm()
      )
    )
  }

  renderFooter() {
    const { downloadHref: { href, onClick }, isMobile } = this.props
    return (
      tag('div', {
        className: bem.element('footer')
      },
        isMobile ? 'Download the ' : 'Install the ',
        tag('a', {
          className: bem.element('extension-link'),
          href,
          onClick
        },
          isMobile ? 'Mix app' : 'Mix browser extension'
        ),
        '.'
      )
    )
  }

  render() {
    return (
      tag(Modal, {
        className: classNames(
          this.props.className,
          bem.block()
        ),
        onDismiss: this.props.onDismiss
      },
        tag('div', {
          className: bem.element('content')
        },
          this.renderInner(),
          this.renderFooter()
        )
      )
    )
  }
}


if (__DEV__) {
  // Prop checking imports
  const PropTypes = require('prop-types')

  ContentAddModal.propTypes = {
    // Flags
    isArticleLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    // Values
    className: PropTypes.string,
    article: PropTypes.shape(ArticleModelRecord.propTypes),
    downloadHref: PropTypes.shape({
      href: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    }),
    url: PropTypes.string,
    // Callbacks
    onDismiss: PropTypes.func
  }
}

module.exports = ContentAddModal
